import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import BalanceIcon from "@mui/icons-material/Balance";
import BarChartIcon from "@mui/icons-material/BarChart";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { ProviderCard } from "./Components/ProviderCard";
import { fetchBillingByMonth, getMockBillingData } from "./utility";
import { Spinner } from "../../components/commonComponents/Spinner/Spinner";
import InvoiceTable from "./InvoiceTable";
import ReconciliationModal from "./Components/BillReconsilation";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
function Billing() {
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showReconciliation, setShowReconciliation] = useState(false);
  
  // State for API data
  const [currentMonth, setCurrentMonth] = useState("");
  const [airtelData, setAirtelData] = useState([]);
  const [bsnlData, setBsnlData] = useState([]);
   const [bsnlRealData, setBsnlRealData] = useState([]);
  const [previousBillsData, setPreviousBillsData] = useState({});
  const [availableMonths, setAvailableMonths] = useState([]);

  // Mock data for payment due dates and disputes
  const paymentDueData = {
    airtel: {
      dueDate: "2026-01-05",
      amount: 84750,
    },
    bsnl: {
      dueDate: "2026-01-07",
      amount: 71000,
    },
  };

  const disputesData = {
    activeDisputes: 1,
    totalDisputes: 3,
  };

  const reconciliationData = {
    lastChecked: "Dec 28, 2025",
    status: "2 discrepancies found",
  };

  // Mock data for reconciliation modal
  const airtelReconciliationData = {
    projectedTotal: 84750,
    actualBillReceived: 86980,
  };

  const bsnlReconciliationData = {
    projectedTotal: 71000,
    actualBillReceived: 71000,
  };

  // Calculate days until due
  const calculateDaysUntilDue = (dueDate) => {
    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  // Generate available months (last 6 months)
  const generateAvailableMonths = () => {
    const months = [];
    const currentDate = new Date();
    
    for (let i = 1; i <= 6; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
      months.push({ label: monthName, month, year });
    }
    
    return months;
  };

  // Fetch billing data on component mount
  useEffect(() => {
    const loadBillingData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Get current month (December 2025)
        const currentDate = new Date();
        // const month = currentDate.getMonth() + 1;
        // const year = currentDate.getFullYear();
        const month =""
        const year = "";
        
        const data = await fetchBillingByMonth(month, year);

        // Set current billing data
        setCurrentMonth(data.currentMonth);
        setAirtelData(data.currentBilling.airtel || []);
        setBsnlData(data.currentBilling.bsnl || []);
        setBsnlRealData(data.currentBilling.bsnlReal || []);

        // Generate available months for dropdown
        setAvailableMonths(generateAvailableMonths());

      } catch (err) {
        setError("Failed to load billing data. Please try again later.");
        console.error("Error loading billing data:", err);
      } finally {
        setLoading(false);
      }
    };

    loadBillingData();
  }, []);

  const handleMonthChange = async (newValue) => {
    if(!newValue){
      setSelectedMonth(null);
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      const month = newValue.month()+1;
      const year = newValue.year();
      const selectedValue = `${month}-${year}`;
      const monthName = newValue.format("MMMM", "YYYY")
      if(month){

        const data = await fetchBillingByMonth(month, year);
     
        
        // Store the fetched data in previousBillsData
        setPreviousBillsData(prev => ({
          ...prev,
          [selectedValue]: {
            airtel: data.currentBilling.airtel || [],
            bsnl: data.currentBilling.bsnl || [],
            label: monthName
          }
        }));
        
        // Only set selectedMonth after data is successfully fetched
        setSelectedMonth(newValue);
         }
      
    } catch (err) {
      console.error("Error fetching month data:", err);
      setError("Failed to load billing data for selected month.");
    } finally {
      setLoading(false);
    }
  };

  const calculateTotals = (data) => {
    if (!data || data.length === 0) return { sims: 0, bill: 0 };
    return data.reduce(
      (acc, item) => ({
        sims: acc.sims + item.totalSims,
        bill: acc.bill + item.monthlyBill,
      }),
      { sims: 0, bill: 0 }
    );
  };

  // const getSelectedMonthData = () => {
  //   if (selectedMonth && previousBillsData[selectedMonth]) {
  //     return previousBillsData[selectedMonth];
  //   }
  //   return null;
  // };
 const getSelectedMonthData = () => {
    if (selectedMonth) {
      const month = selectedMonth.month() + 1;
      const year = selectedMonth.year();
      const key = `${month}-${year}`;
      return previousBillsData[key];
    }
    return null;
  };
  const selectedMonthData = getSelectedMonthData();
  console.log(selectedMonth, "nnn")
  const previousAirtelTotals = selectedMonthData ? calculateTotals(selectedMonthData.airtel) : null;
  const previousBsnlTotals = selectedMonthData ? calculateTotals(selectedMonthData.bsnl) : null;

  const airtelTotals = calculateTotals(airtelData);
  const bsnlTotals = calculateTotals(bsnlData);
  const bsnlRealTotals = calculateTotals(bsnlRealData);

  const navigate = useNavigate()
  const handleRowClick = (rowData)=>{
    console.log(rowData, "rowData")
    navigate("/profilemanagement", {
      state: {
        vendor: rowData?.provider,
        planId: rowData?.planCode,
        month: selectedMonth
          ? selectedMonth.format("MMMMYYYY") // 🔥 January2026
          : null,
       
      },
    });
  }
  // Loading state
  if (loading) {
    return (
      <Spinner />
    );

  }

 

  // Error state
  if (error) {
    return (
      <Box minHeight="100vh" bgcolor="#fcfcfcff" p={4} sx={{ mt: 8 }}>
        <Alert severity="error" sx={{ maxWidth: 600, mx: "auto" }}>
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box minHeight="100vh" bgcolor="#fcfcfcff" p={4} sx={{ mt: 8 }}>
      <Box maxWidth="100%" mx="auto">
        {/* Page Header */}
        <Box mb={4}>
          <Box display="flex" alignItems="center" mb={1}>
            <CheckCircleIcon color="primary" sx={{ mr: 1, fontSize: 32 }} />
            <Typography variant="h4" fontWeight={700} color="primary">
              Total Bill
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" ml={5}>
            Overview of total billing across service providers
          </Typography>
        </Box>

        {/* Payment Due Alerts */}
        {/* <Grid container spacing={2} mb={2}>
          {calculateDaysUntilDue(paymentDueData.airtel.dueDate) <= 7 && (
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "#FEF3C7",
                  border: "2px solid #FCD34D",
                  borderRadius: 2,
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <Box display="flex" alignItems="center">
                  <AccessAlarmIcon sx={{ color: "#DC2626", fontSize: 32, mr: 2 }} />
                  <Box>
                    <Typography fontWeight={700} color="#92400E">
                      Payment Due in {calculateDaysUntilDue(paymentDueData.airtel.dueDate)} days
                    </Typography>
                    <Typography fontSize="14px" color="#78350F">
                      Airtel - ₹{paymentDueData.airtel.amount.toLocaleString()}
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#2563EB",
                    fontWeight: 700,
                    "&:hover": { backgroundColor: "#1D4ED8" },
                  }}
                >
                  Pay Now
                </Button>
              </Box>
            </Grid>
          )}

          {calculateDaysUntilDue(paymentDueData.bsnl.dueDate) <= 7 && (
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "#FEF3C7",
                  border: "2px solid #FCD34D",
                  borderRadius: 2,
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <Box display="flex" alignItems="center">
                  <AccessAlarmIcon sx={{ color: "#DC2626", fontSize: 32, mr: 2 }} />
                  <Box>
                    <Typography fontWeight={700} color="#92400E">
                      Payment Due in {calculateDaysUntilDue(paymentDueData.bsnl.dueDate)} days
                    </Typography>
                    <Typography fontSize="14px" color="#78350F">
                      BSNL - ₹{paymentDueData.bsnl.amount.toLocaleString()}
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#2563EB",
                    fontWeight: 700,
                    "&:hover": { backgroundColor: "#1D4ED8" },
                  }}
                >
                  Pay Now
                </Button>
              </Box>
            </Grid>
          )}
        </Grid> */}

        {/* Quick Action Cards */}
        {/* <Grid container spacing={2} mb={4}>
          <Grid item xs={12} md={4}>
            <Card
              onClick={() => setShowReconciliation(true)}
              sx={{
                borderLeft: "4px solid #F97316",
                borderRadius: 2,
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
              }}
            >
              <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box display="flex" alignItems="center">
                  <SearchIcon sx={{ color: "#F97316", fontSize: 28, mr: 2 }} />
                  <Box>
                    <Typography fontWeight={700}>Bill Reconciliation</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Compare projected vs actual
                    </Typography>
                  </Box>
                </Box>
                <ArrowForwardIcon sx={{ color: "#9CA3AF" }} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                borderLeft: "4px solid #8B5CF6",
                borderRadius: 2,
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
              }}
            >
              <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box display="flex" alignItems="center">
                  <BalanceIcon sx={{ color: "#8B5CF6", fontSize: 28, mr: 2 }} />
                  <Box>
                    <Typography fontWeight={700}>Disputed Bills</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {disputesData.activeDisputes} active disputes
                    </Typography>
                  </Box>
                </Box>
                <ArrowForwardIcon sx={{ color: "#9CA3AF" }} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                borderLeft: "4px solid #10B981",
                borderRadius: 2,
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": { boxShadow: 4, transform: "translateY(-2px)" },
              }}
            >
              <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box display="flex" alignItems="center">
                  <BarChartIcon sx={{ color: "#10B981", fontSize: 28, mr: 2 }} />
                  <Box>
                    <Typography fontWeight={700}>Annual Summary</Typography>
                    <Typography variant="body2" color="text.secondary">
                      View yearly reports
                    </Typography>
                  </Box>
                </Box>
                <ArrowForwardIcon sx={{ color: "#9CA3AF" }} />
              </CardContent>
            </Card>
          </Grid>
        </Grid> */}

        {/* Provider Cards */}
        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} md={6}>
            <ProviderCard
              provider="Airtel"
              data={airtelData}
              columnName={"Total Bill"}
              totals={airtelTotals}
              color="#E41D2C"
              bgColor="#FEE2E2"
              month={currentMonth}
              onRowClick={handleRowClick}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <ProviderCard
              provider="BSNL"
              data={bsnlData}
              totals={bsnlTotals}
              columnName={"Total Bill"}
              color="#0066B3"
              bgColor="#DBEAFE"
              month={currentMonth}
              onRowClick={handleRowClick}
            />
          </Grid>
           {/* <Grid item xs={12} md={4}>
            <ProviderCard
              provider="BSNL Real Data"
              data={bsnlRealData}
              totals={bsnlRealTotals}
              color="#0066B3"
              bgColor="#DBEAFE"
              month={currentMonth}
              onRowClick={handleRowClick}
            />
          </Grid>  */}
        </Grid>

        {/* Grand Total */}
        {/* <Box
          sx={{
            background: "linear-gradient(90deg, #7c3aed, #4f46e5)",
            borderRadius: 2,
            p: 3,
            color: "#fff",
            boxShadow: 6,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Grand Total SIMs
              </Typography>
              <Typography variant="h4" fontWeight={700}>
                {(airtelTotals.sims + bsnlTotals.sims).toLocaleString()}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Grand Total Monthly Bill
              </Typography>
              <Typography variant="h4" fontWeight={700}>
                ₹{(airtelTotals.bill + bsnlTotals.bill).toLocaleString()}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Projected Month-End Bill
              </Typography>
              <Typography variant="h4" fontWeight={700}>
                ₹2,00,000
              </Typography>
            </Grid>
          </Grid>
        </Box> */}

        {/* Previous Bills Section */}
        <Box mt={6} mb={4}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={3} flexWrap="wrap" gap={2}>
            <Box display="flex" alignItems="center">
              <HistoryIcon color="#1e3a5f" sx={{ mr: 1, fontSize: 32 }} />
              <Typography variant="h4" fontWeight={700} color="#1e3a5f">
                Month Wise Bills
              </Typography>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={["year", "month"]}
              label="Select Month & Year"
              minDate={dayjs("2015-01")}
              maxDate={dayjs()}
              value={selectedMonth}
              onChange={(value)=>{
                setSelectedMonth(value)
              }}
              onAccept={handleMonthChange}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { minWidth: 220 },
                },
              }}
            />
          </LocalizationProvider>
          </Box>

          {!selectedMonth && (
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                borderRadius: 2,
                p: 4,
                textAlign: "center",
              }}
            >
              <Typography variant="body1" color="text.secondary">
                Please select a month from the dropdown to view previous billing details
              </Typography>
            </Box>
          )}

          {selectedMonth && selectedMonthData && (
            <>
              <Typography variant="body2" color="text.secondary" mb={2} ml={1}>
                {/* Billing details for {selectedMonthData.label || selectedMonth} */}
                Billing details for {selectedMonthData.label}-{selectedMonth.year()}
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ProviderCard
                    provider="Airtel"
                    data={selectedMonthData.airtel}
                    totals={previousAirtelTotals}
                    color="#E41D2C"
                    bgColor="#FEE2E2"
                    month={selectedMonthData.label || selectedMonth}
                    onRowClick={handleRowClick}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ProviderCard
                    provider="BSNL"
                    data={selectedMonthData.bsnl}
                    totals={previousBsnlTotals}
                    color="#0066B3"
                    bgColor="#DBEAFE"
                    month={selectedMonthData.label || selectedMonth}
                    onRowClick={handleRowClick}
                  />
                </Grid>
                {/* <Grid item xs={12} md={4}>
                  <ProviderCard
                    provider="BSNL BSNL Activation Data"
                    data={selectedMonthData.bsnl}
                    totals={previousBsnlTotals}
                    color="#0066B3"
                    bgColor="#DBEAFE"
                    month={selectedMonthData.label || selectedMonth}
                    onRowClick={handleRowClick}
                  />
                </Grid> */}
              </Grid>
            </>
          )}
        </Box>
      </Box>
      {/* <InvoiceTable /> */}

      {/* Reconciliation Modal */}
      <ReconciliationModal
        open={showReconciliation}
        onClose={() => setShowReconciliation(false)}
        airtelData={airtelReconciliationData}
        bsnlData={bsnlReconciliationData}
      />
    </Box>
  );
}

export default Billing;
